module.exports = __webpack_public_path__ + "img/words.beb564f0.png";